import {ModulePageProps} from "../../../core/module-pages";
import {JbPageHeaderComponent} from "../../../core/component/jb-page-header.component";
import React, {useEffect, useMemo, useState} from "react";
import {StepTypeEntity} from "../../../../../domain/entity/step-type.entity";
import {useStepTypeRepository} from "../../../../../domain/repository/step-type.repository";
import {ColumnsType} from "antd/es/table";
import {Switch, Table} from "antd";
import {JbTableRowActionsComponent} from "../../../core/component/jb-table-row-actions.component";

export function ListStepTypePage(props: ModulePageProps) {
  const [stepTypes, setStepTypes] = useState<StepTypeEntity[]>([])
  const stepTypeRepo = useStepTypeRepository()

  function loadData() {
    stepTypeRepo.list().then(res => setStepTypes(res.data))
  }
  useEffect(() => {
    loadData()
  }, [])
  
  
  function toggleIsJudicialHearing(entity: StepTypeEntity) {
    entity.isJudicialHearing = !entity.isJudicialHearing;
    return stepTypeRepo.edit(entity.id, entity)
      .then(() => loadData())
  }
  
  function toggleRequireOnlineMeeting(entity: StepTypeEntity) {
    entity.requireOnlineMeeting = !entity.requireOnlineMeeting;
    return stepTypeRepo.edit(entity.id, entity)
      .then(() => loadData())
  }
  
  function remove(id: string) {
    stepTypeRepo.remove(id).then(() => loadData())
  }

  const columns = useMemo<ColumnsType<any>>(() => [
    {
      key: 1,
      title: 'Descrição',
      dataIndex: 'description'
    },
    {
      key: 2,
      title: 'Audiência',
      dataIndex: 'isJudicialHearing',
      render: (enabled,entity) => <Switch checked={enabled} onClick={() => toggleIsJudicialHearing(entity)} />
    },
    {
      key: 4,
      title: '',
      dataIndex: 'id',
      align: 'right',
      render: id => (
        <JbTableRowActionsComponent
          onEdit={() => props.navigator(`edit/${id}`) }
          onRemove={() => remove(id)}
        />
      )
    }
  ], [])

  return (
    <>
      <JbPageHeaderComponent
        title={'Parametrizações / Tipo Movimentação'}
        description={'Parametrização dos tipos de moviumentação'}
        onCreateLink={`${props.prefix}/create`}
      />
      <Table
        loading={stepTypeRepo.loading}
        columns={columns}
        dataSource={stepTypes}
      />
    </>
  )
}
